import assetPath from '/app/packages/lebenslauf/articles/src/assets/lebenslauf-unterschreiben.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')